"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Api = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 20,
  height: 10,
  viewBox: "0 0 20 10",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M7.461 10l-.659-2.37H3.487L2.827 10H.75L3.96 0h2.357l3.222 10H7.46zm-1.12-4.142l-.659-2.316a28.305 28.305 0 00-.167-.592 70.716 70.716 0 00-.206-.743c-.066-.254-.12-.474-.161-.66a72.587 72.587 0 01-.522 1.996l-.654 2.315h2.37zM13.188.04c1.173 0 2.03.278 2.569.832.539.55.808 1.308.808 2.275 0 .436-.06.854-.18 1.254-.12.395-.317.747-.59 1.055-.27.31-.631.554-1.083.736-.452.177-1.01.266-1.673.266h-.72V10h-2.036V.04h2.905zm-.1 1.731h-.769v2.957h.527c.36 0 .674-.053.939-.157.265-.105.47-.268.616-.49.145-.223.217-.51.217-.859 0-.49-.124-.854-.373-1.09-.248-.24-.634-.36-1.157-.36zM17.627 10V.04h2.123V10h-2.123z",
  className: "fill"
}));
var _default = exports.default = Api;